import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  GeneralCardElements,
  OrderedCardsList,
  User,
  CourseModel,
  CourseModelProps,
} from "@/types";
import { IonGrid, IonRow, IonCol } from "@ionic/vue";
import { reactive, ref } from "vue";
import { useStore } from "vuex";
import { executeLink, getCurrentElement, getCustomMessage } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropositionsHistory',
  async setup(__props) {

let __temp: any, __restore: any

const is_nothing_selected = () => selected_year_index.value == -1;
const find_session = (
  school_years: OrderedCardsList<GeneralCardElements>,
  id?: string
) =>
  school_years.cards[""].findIndex((a: GeneralCardElements) => {
    if (id != undefined) {
      return a.id == id;
    } else {
      return a.selected;
    }
  });
const changeSelection = async () => {
  if (selected_year_index.value != -1) {
    selectedChange();
  }

  const tmp_selected = find_session(school_years, store.state.event.data.id);
  if (selected_year_index.value == tmp_selected) {
    selected_year_index.value = -1;
    year_propositions.cards = {
      "": [],
    };
  } else {
    selected_year_index.value = tmp_selected;

    for (const proposition of propositions) {
      if (
        proposition.creation_school_year ==
        parseInt(school_years.cards[""][selected_year_index.value].id)
      ) {
        year_propositions.cards[""].push(proposition.toCard(user, true)); //<!-- ? chiedere se vogliono preferences anche in project class
      }
    }
    selectedChange();
  }
};
const selectedChange = (
  index = selected_year_index.value,
  value = !school_years.cards[""][index].selected
) => {
  school_years.cards[""][index].selected = value;
  trigger.value++;
};

const store = useStore();
const user = User.getLoggedUser() as User;

const school_years: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const empty_propositions: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {},
});
const year_propositions: OrderedCardsList<GeneralCardElements> = reactive({
  order: [],
  cards: {
    "": [],
  },
});
const trigger = ref(0);
const propositions: CourseModel[] = (
  ([__temp,__restore] = _withAsyncContext(async () => executeLink(
  "/v1/propositions?recent_models=false",
  async (response: any) =>
    Promise.all(
      response.data.data.map(async (a: CourseModelProps) => {
        const tmp_proposition = new CourseModel(a);
        await tmp_proposition.loadParms();
        return tmp_proposition;
      })
    ),
  () => []
))),
  __temp = await __temp,
  __restore(),
  __temp
);
const actual_teacher_id = user.id;
const selected_year_index = ref(-1);

;(
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/teachers/" + actual_teacher_id + "/active_years", //<!-- TODO (5): trovare api per admin
  (response) => {
    let id: string;

    school_years.cards[""] = response.data.data.map((a: any) => {
      id = "" + a.year;

      return {
        id: id,
        group: "",
        title: getCustomMessage("title", "" + a.year),
        selected: false,
        link: {
          event: "change_selection",
          data: {
            id: id,
          },
        },
      };
    });
  }
))),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_list_card = _resolveComponent("list-card")!

  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), {
            size: "12",
            "size-md": "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_list_card, {
                title: _unref(getCustomMessage)('title', _unref(getCurrentElement)('school_years')),
                emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)('no_school_years')
            )
          ,
                cards_list: school_years,
                colors: {
            list_borders: {
              name: 'black',
              type: 'var',
              alpha: 0.25,
            },
          },
                onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (changeSelection()))
              }, null, 8, ["title", "emptiness_message", "cards_list", "colors"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), {
            size: "12",
            "size-md": "6"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_list_card, {
                key: trigger.value,
                title: _unref(getCustomMessage)('title', _unref(getCurrentElement)('courses')),
                emptiness_message: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)(
                is_nothing_selected()
                  ? 'teacher_learning_session_selection_message'
                  : 'no_project_classes'
              )
            )
          ,
                colors: {
            list_borders: {
              name: 'black',
              type: 'var',
              alpha: 0.25,
            },
          },
                cards_list: 
            is_nothing_selected() ? empty_propositions : year_propositions
          
              }, null, 8, ["title", "emptiness_message", "colors", "cards_list"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})